import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: "Mon plus gros problème était la planification des séances. Football Prêt m'a donné toute une saison structurée. Je passe moins de temps à planifier et plus de temps à entraîner.",
  author: 'Michael T.',
  role: 'Entraîneur de Football Jeunes'
}, {
  quote: "La Bibliothèque de Séances et le Système d'Évaluation des Joueurs ont complètement changé la façon dont j'organise mon équipe. Ce système vaut bien plus que son prix.",
  author: 'James R.',
  role: "Entraîneur d'Académie"
}];
export function Testimonials() {
  return <section className="py-20 bg-navy-900 relative" data-id="element-216" data-mp="2s1ylafcyn1mb">
      <div className="container mx-auto px-4" data-id="element-217" data-mp="2s39qmjm20hfj">
        <div className="text-center mb-16" data-id="element-218" data-mp="v96jbxhmprie">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-219" data-mp="v8wtc9wl3kcp">
CE QUE DISENT LES AUTRES ENTRAÎNEURS
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-220" data-mp="7a4uyrz8zdk9">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-950 border border-navy-800 rounded-2xl p-8 relative" data-id="element-221" data-mp="zw68onx3vnfl" data-mpi={index}>
              <Quote className="absolute top-6 right-6 w-12 h-12 text-navy-800" data-id="element-222" data-mp="1nma96mezz72d" />

              <div className="flex gap-1 mb-6" data-id="element-223" data-mp="1xhqvdh4steqb">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-224" data-mp="1sj5wpm57333z" data-mpi={i} />)}
              </div>

              <p className="text-xl text-gray-300 italic mb-8 relative z-10" data-id="element-225" data-mp="1oj5hhza9unvv">
                "{testimonial.quote}"
              </p>

              <div data-id="element-226" data-mp="1ejoa9dfdg1xs">
                <div className="font-oswald text-xl text-white uppercase tracking-wide" data-id="element-227" data-mp="1ejwrtimfvvfb">
                  {testimonial.author}
                </div>
                <div className="text-gold-500 text-sm font-medium" data-id="element-228" data-mp="14tbk95osfgk9">
                  {testimonial.role}
                </div>
                {'detail' in testimonial && testimonial.detail && <div className="text-gray-500 text-sm mt-0.5" data-id="element-229" data-mp="vsnh560xn0m5">
                    {testimonial.detail}
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}